import m from "../../geodata/es2015/congoDRHigh";
window.am4geodata_congoDRHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/congoDRHigh.js
// module id = null
// module chunks = 